export class ObjetoEntrada {
    ticketUsuario: string;
}
